import { useState, useEffect } from 'react';
import '../../App.css';
import './user-control.css';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

// images

// types
import { NotificationType } from '../../utils/types';

// classes
import RoundButton from '../../tools/round-button';
import UserControlDropdownMenu from './user-control-dropdown-menu';
import UserAccountButton from './user-account-button';

// types relating to events.
import { Event, EventType, EventTarget } from '../../utils/events';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

import { setUserDropdownMenuDisplayed } from '../../app-slice';
import { setInitials } from './user-control-slice';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C O M P O N E N T   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function UserControl(props: { buttonHandler: any }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();

  // global state variables.
  const sG_username: string | undefined = useAppSelector(
    (state) => state.global.username,
  );
  const sG_loggedIn: boolean | undefined = useAppSelector(
    (state) => state.global.loggedIn,
  );

  // app state variables.
  const sNotifications: NotificationType[] = useAppSelector(
    (state) => state.app.notifications,
  );
  const sUserDropdownMenuDisplayed: boolean = useAppSelector(
    (state) => state.app.userDropdownMenuDisplayed,
  );

  // local state variables.
  const sInitials: string = useAppSelector((state) => state.userControl.initials);

  //	--------------------------------------------------------------------------
  //
  //	H O O K S
  //
  //	--------------------------------------------------------------------------

  useEffect(() => {
    //
    // loop over all the characters of the username to extract the initials.
    let initials: string = '';
    let spaceLast: boolean = true;
    if (sG_username !== undefined && sG_loggedIn === true) {
      for (let index = 0; index < sG_username.length; index++) {
        if (spaceLast === true && initials.length < 3)
          initials += sG_username.slice(index, index + 1);
        spaceLast = sG_username.slice(index, index + 1) === ' ';
      }
    }

    // update initials.
    dispatch(setInitials(initials));
    //
  }, [sG_loggedIn, sG_username]);

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  // translation function
  const { t } = useTranslation();

  //	--------------------------------------------------------------------------
  //
  //	E V E N T   D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  const [sEventToDropdownMenu, setEventToDropdownMenu] = useState<any>(undefined);

  const eventToDropdownMenu = (newFunction: any) => {
    setEventToDropdownMenu(() => newFunction);
  }; // eventToDropdownMenu

  //	--------------------------------------------------------------------------
  //
  //	F U N C T I O N S
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	handle event coming from the parent component.
  //
  //	------------------------------------------------------------

  function eventHandler(args: { event: Event }) {
    //
    console.log('user-control event handler fires', EventType[args.event.eventType]);

    // if the incoming event is global, or destined for a child component, then
    // pass it on.
    if (
      args.event.eventTarget === EventTarget.GLOBAL &&
      sEventToDropdownMenu !== undefined
    ) {
      sEventToDropdownMenu({ event: args.event });
    }
    //
  } // eventHandler

  //	-------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	-------------------------------------------------

  // otherwise, display the user button.
  return (
    <div className="user-control-container">
      <UserAccountButton buttonHandler={props.buttonHandler} />

      {sUserDropdownMenuDisplayed && (
        <UserControlDropdownMenu buttonHandler={props.buttonHandler} />
      )}
    </div>
  );
  //
} // UserControl
